import type { ResponsiveImageData } from './images'
import { images } from './images'

export const contact = {
  phoneDisplay: '949.218.2900',
  phoneHref: 'tel:+19492182900',
  email: 'George@diamond.salon',
  address: '31831 Camino Capistrano Ste 201, San Juan Capistrano, CA 92675',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=31831+Camino+Capistrano+Ste+201+San+Juan+Capistrano+CA+92675',
  bookingUrl: 'https://www.vagaro.com/diamondsalon2',
  shopUrl: 'https://shop.saloninteractive.com/store/Diamondsalon',
  instagramUrl: 'https://www.instagram.com/diamondsalon.sjc',
  yelpUrl: 'https://www.yelp.com/biz/jdiamond-salon-san-juan-capistrano',
}

export type NavItem = { label: string; to: string; external?: boolean; featured?: boolean }

export const navItems: NavItem[] = [
  { label: 'Salon & Spa', to: '/' },
  { label: 'Team', to: '/team' },
  { label: 'Join Us', to: '/join-our-team', featured: true },
  { label: 'Our Space', to: '/our-space' },
  { label: 'Services', to: '/services' },
  { label: 'Products', to: '/products' },
  { label: 'Shop', to: contact.shopUrl, external: true },
  { label: 'Giving Back', to: '/giving-back' },
  { label: 'Contact', to: '/contact' },
]

export type TeamMember = {
  name: string
  role: string
  image?: ResponsiveImageData
  imageFit?: 'cover' | 'contain'
  imagePosition?: string
  bookingUrl?: string
  instagram?: string
  websiteUrl?: string
  portfolioUrl?: string
  links?: TeamProfileLink[]
  bio: string[]
}

export type TeamProfileLink = {
  label: string
  url: string
}

export const teamMembers: TeamMember[] = [
  {
    name: 'George Portillo',
    role: 'Manager / Stylist',
    image: images['team-george'],
    imagePosition: '50% 38%',
    instagram: 'https://www.instagram.com/georgeportillohair',
    bio: [
      'In 2018 George packed his Chicago life in a bag and was on the next flight to LA. He knew this wasn’t going to be easy, but with a heart full of dreams nothing was going to get in his way. In a short period of time, George started to build a name for himself in Orange County. His fun, Latin Midwest personality and technical creative work won his salon guests over and keeps them coming back for more.',
      'The beauty industry is constantly changing, and knowledge is key in a salon. That translated well for George as he took on an educator role with Easihairpro, creating successful salon professionals nationwide. He continues to find ways to elevate his career and take it to the next level.',
      'Now he has joined the Diamond family as a full-time salon director and hair artist. With a big smile on his face, George is excited to grow and rebuild the salon. If you have any questions or concerns, please do not hesitate to reach out.',
    ],
  },
  {
    name: 'Azita',
    role: 'Stylist',
    image: images['team-azita'],
    imagePosition: '50% 30%',
    bio: [
      'As a master stylist and makeup artist, Azita has performed her magic in photoshoots, runway shows, award shows, weddings, and special events. Regardless of the event, she will always leave you camera ready.',
      'Azita is a perfectionist who does not stop with adequate. She makes it her goal to ensure you are thrilled with your look every time you are in her chair.',
    ],
  },
  {
    name: 'Amanda Cathcart',
    role: 'Stylist',
    image: images['team-megyn'],
    imagePosition: '50% 82%',
    bio: [
      'Born and raised in Laguna Niguel, Amanda has always been passionate about all things hair and beauty. She has worked behind the chair for three years and consistently dedicates herself to growing and refining her technique. With an eye for perfection, she is sure to provide clean and desired results.',
    ],
  },
  {
    name: 'Carolyn Gallegos',
    role: 'Stylist',
    image: images['team-carolyn'],
    imagePosition: '50% 8%',
    bio: [
      'Carolyn is a SoCal native who has lived in Capistrano Beach over the past years. With 30 years of experience, she specializes in classic and traditional styles. If you love short, pixie, or bob haircuts, then she is the stylist for you.',
      'The best part of this journey has been making lasting friendships with her salon guests. Carolyn loves the fun and exciting energy at the salon. It makes every day feel less like work when the team shares knowledge.',
    ],
  },
  {
    name: 'Elizabeth Laplant',
    role: 'Stylist',
    bio: [
      'Elizabeth has been in the industry for more than 20 years. After graduating from Paul Mitchell in 2010, she found that hair was her true passion. The beauty industry is constantly evolving, and education is key.',
      'Each head of hair is as unique as the client. Salon services need to cater to the individual and the experience. She looks forward to each and every client visit, always providing her best.',
    ],
  },
  {
    name: 'Lindsey Vitta',
    role: 'Stylist',
    image: images['team-lindsey'],
    imagePosition: '50% 72%',
    bio: [
      'Lindsey has always had a natural talent and passion for hair. After graduating from Vidal Sassoon Academy, she had the opportunity to work at thriving salons for the past 13 years and attend many classes to further her career. One highlight was styling hair for runway shows at Mercedes-Benz Fashion Week in New York. She specializes in color, extensions, and precision haircuts.',
      'Lindsey strives to give her guests a style that fits their personality, can be styled at home, and comes with the knowledge needed to care for it. When she is not behind the chair, Lindsey enjoys spending time with her family, two Boston terriers, and traveling.',
    ],
  },
  {
    name: 'Lisa Engelsman',
    role: 'Stylist',
    image: images['team-elizabeth'],
    imagePosition: '50% 82%',
    bio: [
      'Lisa Engelsman is passionate about delivering an exceptional cut and color experience by taking the time and care to actively listen to each client’s wants and needs and completing a thorough consultation.',
      'Clients benefit from Lisa’s many years of salon experience and ownership, combined with a broad cut and coloring education base from Aveda and Davines.',
    ],
  },
  {
    name: 'Sylvia Rico',
    role: 'Esthetician',
    image: images['team-sylvia'],
    imagePosition: '50% 66%',
    bio: [
      'The mission of Sylvia Rico Esthetics is to provide outstanding services that meet the goals and needs of every client. The relationship is built on confidence, understanding, and a genuine intention to provide the highest level of satisfaction in a relaxed and inviting atmosphere.',
      'As a veteran esthetician for 17 years, Sylvia strives for excellence and takes pride in delivering personalized, dedicated service. She is constantly learning and has a genuine passion for innovative techniques that help clients achieve their goals.',
    ],
  },
  {
    name: 'Megyn Garcia',
    role: 'Stylist',
    bio: [],
  },
]
